import React, { useRef } from 'react';
import { GalleryToolbar } from './GalleryToolbar';
import { GalleryGrid } from './GalleryGrid';
import { GalleryPreviewModal } from './GalleryPreviewModal';
import { useClientGallery } from './useClientGallery';
import { CameraCapture } from './CameraCapture';
import '../../Clientes.css';
import { Images } from 'lucide-react';

export default function ClientGallery({ clientId }: { clientId: string }) {
    const {
        items,
        loadingList,
        uploading,
        preview,
        openCamera,
        canShowEmpty,
        setPreview,
        setOpenCamera,
        addFiles,
        removeItem,
    } = useClientGallery(clientId);

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const videoInputRef = useRef<HTMLInputElement | null>(null);

    const triggerPickImages = () => fileInputRef.current?.click();
    const triggerPickVideos = () => videoInputRef.current?.click();

    const total = items.length;

    return (
        <div>
            <div className="cli-gallery-bar">
                <div className="px-1 text-sm text-base-content/60">
                    {loadingList ? 'Carregando...' : `${total} ${total === 1 ? 'mídia' : 'mídias'}`}
                </div>

                <GalleryToolbar
                    uploading={uploading}
                    onOpenCamera={() => setOpenCamera(true)}
                    onPickImages={triggerPickImages}
                    onPickVideos={triggerPickVideos}
                />

                {/* Inputs escondidos + reset pra permitir re-selecionar o mesmo arquivo */}
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    className="hidden"
                    onChange={(e) => {
                        addFiles(Array.from(e.target.files || []));
                        e.currentTarget.value = '';
                    }}
                />

                <input
                    ref={videoInputRef}
                    type="file"
                    accept="video/*"
                    multiple
                    className="hidden"
                    onChange={(e) => {
                        addFiles(Array.from(e.target.files || []));
                        e.currentTarget.value = '';
                    }}
                />
            </div>

            {loadingList && !total && (
                <div className="cli-gallery-grid" aria-busy="true">
                    {[0, 1, 2, 3].map((item) => (
                        <div key={item} className="sf-skeleton aspect-square" />
                    ))}
                </div>
            )}

            {canShowEmpty && (
                <div className="sf-state">
                    <Images aria-hidden />
                    <h2>Nenhuma mídia ainda</h2>
                    <p>Adicione fotos e vídeos dos atendimentos deste cliente.</p>
                </div>
            )}

            <GalleryGrid items={items} onSelect={(it) => setPreview(it)} />

            <GalleryPreviewModal preview={preview} onClose={() => setPreview(null)} onRemove={removeItem} />

            {openCamera && (
                <CameraCapture
                    clientId={clientId}
                    onClose={() => setOpenCamera(false)}
                    onCaptured={(file: File) => addFiles([file])}
                />
            )}
        </div>
    );
}
